import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => {
  const t = localStorage.getItem("bc_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const TONE = {
  approved: "border-emerald-600 text-emerald-400 bg-emerald-900/20",
  rejected: "border-red-600 text-red-400 bg-red-900/20",
  pending: "border-amber-600 text-amber-300 bg-amber-900/20",
  received: "border-amber-600 text-amber-300 bg-amber-900/20",
};

export const WhatsAppFlowStatus = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/admin/whatsapp-flow/status`, { headers: authHeaders() });
      setData(data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="luxury-card p-4 mb-6" data-testid="wa-flow-status">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="eyebrow flex items-center gap-1.5"><MessageCircle size={12} className="text-emerald-400" /> WhatsApp booking flow</div>
        <div className="flex items-center gap-2">
          {data && (
            <span className={`text-[10px] tracking-[0.16em] uppercase px-2 py-1 border ${data.booking_flow_live ? TONE.approved : TONE.pending}`} style={{ borderRadius: 0 }} data-testid="wa-flow-live">
              {data.booking_flow_live ? "New flow live" : "Using legacy template"}
            </span>
          )}
          <button onClick={load} disabled={loading} className="p-1.5 border border-white/10 text-zinc-400 hover:text-white" style={{ borderRadius: 0 }} data-testid="wa-flow-refresh" title="Refresh approval status">
            <RefreshCw size={13} className={loading ? "animate-spin" : ""} />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        {(data?.templates || []).map((t, i) => (
          <div key={t.label} className="border border-white/10 bg-black/30 p-3" style={{ borderRadius: 0 }} data-testid={`wa-template-${i}`}>
            <div className="text-xs text-white">{t.label}</div>
            <div className="text-[10px] text-zinc-500 truncate">{t.name || t.sid || "—"}</div>
            <span className={`mt-2 inline-block text-[10px] tracking-[0.14em] uppercase px-2 py-0.5 border ${TONE[t.status] || "border-zinc-700 text-zinc-400"}`} style={{ borderRadius: 0 }} data-testid={`wa-template-status-${i}`}>
              {t.status === "received" ? "pending" : t.status.replace("_", " ")}
            </span>
            {t.rejection_reason && <div className="mt-1 text-[10px] text-red-400">{t.rejection_reason}</div>}
          </div>
        ))}
        {!data && !loading && <div className="text-xs text-zinc-500">Could not load template status.</div>}
      </div>
    </div>
  );
};
